import React from 'react';
import './Text.style.css';

const Text = ({
  children,
  style = {},
  size = 16,
  weight = 400,
  maxLine = 1,
  color,
  className,
  onClick,
  ...props
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <p
      className={`text_comp ${className}`}
      style={{
        fontSize: size,
        fontWeight: weight,
        WebkitLineClamp: maxLine,
        color: color,
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
      onClick={onClick}
      {...props}
    >
      {children}
    </p>
  );
};

export default Text;
